<template>
  <div class="absolute sidebar-steps bg-white">
    <div>
      <ul class="activity-timeline">
        <li
          class="step-cursor"
          v-for="(step, index) in steps"
          :key="`step-${index}`"
        >
          <div
            @click="navigateToSelectedStep(step.order)"
            :key="`timeline-icon-${index}`"
            class="timeline-icon"
            :class="
              step.order == currentStep
                ? 'bg-primary'
                : step.completed
                ? 'bg-success'
                : 'bg-grey-light'
            "
          >
            <feather-icon
              :icon="
                step.order == currentStep
                  ? step.icon
                  : step.completed
                  ? 'CheckIcon'
                  : step.icon
              "
              svgClasses="text-white stroke-current w-5 h-5"
            />
          </div>
          <div
            class="timeline-info mb-20"
            :key="`timeline-info-${index}`"
            @click="navigateToSelectedStep(step.order)"
          >
            <p class="font-semibold">{{ step.title }}</p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "cs-sidebar-steps",
  props: {
    parent: {
      type: String
    }
  },
  computed: {
    ...mapState("basicInfo", ["basicInfo"]),
    ...mapState("step", ["steps", "currentStep"])
  },
  methods: {
    async navigateToSelectedStep(order) {
      await this.$store.dispatch("step/updateCurrentStep", {
        order
      });
      this.navigate();
    },
    navigate() {
      const { path } = this.steps[this.currentStep];

      const { params, name } = this.$router.history.current;
      if (name === path) {
        return;
      }

      this.$router.push({
        name: path,
        params
      });
    },
    ...mapActions("step", ["updateCurrentStep", "perfomSucessfullResponse"])
  }
};
</script>

<style lang="scss">
.step-cursor {
  cursor: pointer;
}
.sidebar-steps {
  max-width: 230px;
  max-height: calc(100vh - 50.38px);
  padding: 2em 1em;
  overflow-y: scroll;
}
</style>
